export const HOME = {
  emergentLink: "home-emergent-link",
};

export const TID = {
  // Hero
  heroSection: "hero-section",
  heroLogo: "hero-logo",
  heroEyebrow: "hero-eyebrow",
  heroHeadline: "hero-headline",
  heroSubline: "hero-subline",
  heroCta: "hero-cta-button",
  showreelInkReveal: "showreel-ink-reveal",
  showreelIframe: "showreel-iframe",
  hubspotForm: "hubspot-form-wrap",
  logoStrip: "logo-strip",

  // Testimonials
  testimonialsSection: "testimonials-section",
  testimonialCollectingCars: "testimonial-collecting-cars",
  testimonialRembrandt: "testimonial-rembrandt",

  // Final CTA + footer
  finalCtaSection: "final-cta-section",
  finalCtaButton: "final-cta-button",
  footer: "site-footer",
  termsLink: "terms-link",

  // Sticky mobile
  stickyMobileCta: "sticky-mobile-cta",
  stickyCtaButton: "sticky-cta-button",
};
